import "./styles.css";
import { Color } from "@tiptap/extension-color";
import TextStyle from "@tiptap/extension-text-style";
import ListItem from "@tiptap/extension-list-item";

import { EditorContent, useEditor } from "@tiptap/react";
import StarterKit from "@tiptap/starter-kit";
import React from "react";
import { CreateContent } from "./CreateContent";
import { Button, Box } from "@mui/material";
import SendIcon from "@mui/icons-material/Send";

const MenuBar = ({ editor }) => {
  if (!editor) {
    return null;
  }

  return (
    <div className="editor-toolbar">
      <button
        onClick={() => editor.chain().focus().toggleBold().run()}
        disabled={!editor.can().chain().focus().toggleBold().run()}
        className={`toolbar-btn ${editor.isActive("bold") ? "is-active" : ""}`}
      >
        B
      </button>
      <button
        onClick={() => editor.chain().focus().toggleItalic().run()}
        disabled={!editor.can().chain().focus().toggleItalic().run()}
        className={`toolbar-btn ${editor.isActive("italic") ? "is-active" : ""}`}
      >
        <em>I</em>
      </button>
      <button
        onClick={() => editor.chain().focus().toggleStrike().run()}
        disabled={!editor.can().chain().focus().toggleStrike().run()}
        className={`toolbar-btn ${editor.isActive("strike") ? "is-active" : ""}`}
      >
        <s>S</s>
      </button>
      <div className="toolbar-divider" />
      <button
        onClick={() => editor.chain().focus().toggleHeading({ level: 3 }).run()}
        className={`toolbar-btn ${editor.isActive("heading", { level: 3 }) ? "is-active" : ""}`}
      >
        H
      </button>
      <button
        onClick={() => editor.chain().focus().toggleBulletList().run()}
        className={`toolbar-btn ${editor.isActive("bulletList") ? "is-active" : ""}`}
      >
        <img src="./icon/bullet-list.svg" width="16" alt="bullet list" />
      </button>
      <button
        onClick={() => editor.chain().focus().toggleOrderedList().run()}
        className={`toolbar-btn ${editor.isActive("orderedList") ? "is-active" : ""}`}
      >
        <img src="./icon/ordered-list.svg" width="16" alt="ordered list" />
      </button>
    </div>
  );
};

const EditorCus = ({
  operation_details,
  booking_details,
  onSendEmailClick,
}) => {
  let content_init = CreateContent(operation_details, booking_details);

  const editor = useEditor({
    extensions: [
      Color.configure({ types: [TextStyle.name, ListItem.name] }),
      StarterKit.configure({
        bulletList: {
          keepMarks: true,
          keepAttributes: false,
        },
        orderedList: {
          keepMarks: true,
          keepAttributes: false,
        },
      }),
      TextStyle.configure({ types: [ListItem.name] }),
    ],
    content: content_init,
  });

  return (
    <Box className="editor-wrapper">
      <MenuBar editor={editor} />
      <Box className="editor-content-area">
        <EditorContent editor={editor} />
      </Box>
      <Box className="editor-footer">
        <Button
          variant="contained"
          size="small"
          endIcon={<SendIcon sx={{ fontSize: 16 }} />}
          sx={{
            borderRadius: "20px",
            textTransform: "none",
            fontWeight: 500,
            fontSize: 13,
          }}
          onClick={() => {
            let html_send = editor.getHTML();
            onSendEmailClick(html_send);
          }}
        >
          Send Email
        </Button>
      </Box>
    </Box>
  );
};

export default EditorCus;
